export default __webpack_public_path__ + "static/media/img (1).6d0c9dc0.jpg";